import { Container, Col } from "react-bootstrap";
import styled from "styled-components";
import { ArrowLeftCircle } from "react-bootstrap-icons";

/* Full layout container */
export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

/* Fixed Navbar */
export const FixedTopnav = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  height: 65px;
  background: #112557;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
`;

/* Wrapper for sidebar + content */
export const BodyWrapper = styled.div`
  display: flex;
  margin-top: 65px; /* Offset for navbar height */
  height: calc(100vh - 65px);
  overflow: hidden;
`;

/* Sidebar section */
export const SidebarWrapper = styled.div`
  width: ${(props) => (props.open ? "240px" : "70px")};
  background: #ffffff;
  border-right: 1px solid #e5e5e5;
  position: relative;
  transition: width 0.3s ease;
  overflow: hidden;
`;

/* Scrollable content */
export const ContentWrapper = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto; /* Only this should scroll */
  padding: 25px;
  background: #f7f9fc;
  transition: margin-left 0.3s ease;
`;

/* Heading */
export const PageHeader = styled.h1`
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 20px;
`;

/* Toggle icon */
export const LeftArrowCircle = styled(ArrowLeftCircle)`
  position: absolute;
  top: 20px;
  right: -10px;
  width: 26px;
  height: 26px;
  cursor: pointer;
  color: #737373;
  transition: all 0.2s;

  &:hover {
    color: #0d6efd;
    transform: scale(1.1);
  }
`;

export const sidebarVariants = {
  open: {
    width: 260,
    boxShadow: "2px 0 12px rgba(0,0,0,0.08)",
    transition: { type: "spring", stiffness: 120, damping: 20 },
  },
  closed: {
    width: 80,
    boxShadow: "2px 0 8px rgba(0,0,0,0.04)",
    transition: { type: "spring", stiffness: 120, damping: 20 },
  },
};

export const pageVariants = {
  initial: { opacity: 0, y: 10, scale: 0.98 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.25, ease: "easeOut" },
  },
};

export const toggleIconVariants = {
  open: { rotate: 0 },
  closed: { rotate: 180 },
};